import {
  InteractionStepType,
  InteractionStepConfig,
  IndexedInteractionStepResponse,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';
import { IMultiTurnThreadHistory } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ThreadHistory.interface';
import { isConditionallyVisible, isStepVisible } from '@scale/shared/chat/api';
import { ReviewLevel } from '@scale/shared-types';
import { ContextDirectionsTaskComponent } from './ContextDirectionsTaskComponent';

import { schema } from './validation';

import { StepDescriptor } from '../stepDescriptor/StepDescriptor';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';

class ContextDirectionsDescriptor extends StepDescriptor<InteractionStepType.ContextDirections> {
  type = InteractionStepType.ContextDirections;
  title = InteractionStepConfig[InteractionStepType.ContextDirections].title;
  description = InteractionStepConfig[InteractionStepType.ContextDirections].description;

  validationSchema = schema;

  ViewComponent = ContextDirectionsTaskComponent;

  isResponseValid(
    response: IndexedInteractionStepResponse,
    stepParams: StepParamsForTypeWithStage<InteractionStepType.ContextDirections>,
    history: IMultiTurnThreadHistory,
    reviewLevel?: ReviewLevel,
  ) {
    if (
      !isStepVisible(stepParams, reviewLevel) ||
      !isConditionallyVisible(
        stepParams,
        history.responses,
        response.index,
        history.threadParams.templateVariables,
        reviewLevel,
      )
    ) {
      return { canSubmit: true, submitTooltip: '' };
    }

    if (response.context && response.context.hasFeedback && !response.context.didRateFeedback) {
      return { canSubmit: false, submitTooltip: 'Please rate the feedback.' };
    }

    return { canSubmit: true, submitTooltip: '' };
  }
  generateEmptyResponse() {
    return {
      type: InteractionStepType.ContextDirections,
      context: {},
      output: '',
    };
  }
}

registerStepDescriptor({
  type: InteractionStepType.ContextDirections,
  descriptor: new ContextDirectionsDescriptor(),
});
